import { countrySwitch } from 'services/geo-management'
import { yupArray } from 'services/yup/custom-schemas/array'
import { yupIgnore } from 'services/yup/helpers'
import { yupNumber } from 'services/yup/custom-schemas/number'
import { yupString } from 'services/yup/custom-schemas/string'
import { YupSchema } from 'services/yup/types'
import { DayMonthLabel } from 'types/common'
import { customerBaseVS } from './customerBase'
import { yupObject } from 'services/yup'
import {
  BudgetDateRange,
  Member,
  MembershipRole,
  Organization,
  OrganizationITA,
} from 'services/api/entities/crm/organizations/types/internal/organization-model'

const organizationMemberVS: YupSchema<Member> = yupObject().shape({
  role: yupString<MembershipRole>().required(),
  budgetSpent: yupNumber(),
  userName: yupString(),
  budget: yupIgnore(),
  budgetDueDate: yupIgnore(),
  userId: yupIgnore(),
  /**
   * @property allowFullAddressCoverage
   * is ignored because it only serves the purpose of
   * controlling other inputs in bulk, and therefore
   * its value is not relevant
   */
  hasFullAddressCoverage: yupIgnore(),
})

const budgetDateRangeVS: YupSchema<BudgetDateRange> = yupObject().shape({
  budgetSpentDateTo: yupString<DayMonthLabel>(),
  budgetSpentDateFrom: yupString<DayMonthLabel>(),
})

const baseOrganizationVS: YupSchema<Organization> = customerBaseVS.shape({
  budgetDateRange: yupArray(budgetDateRangeVS).optional(),
  members: yupArray(organizationMemberVS).min(1),
  image: yupIgnore(),
  /**
   * @property allowFullAddressCoverage
   * is ignored because it only serves the purpose of
   * controlling other inputs in bulk, and therefore
   * its value is not relevant
   * */
  allowFullAddressCoverage: yupIgnore(),
})

const organizationITAVS: YupSchema<OrganizationITA> = baseOrganizationVS.shape({
  pec: yupString().required(),
  sdi: yupString().required(),
  vat: yupString().required(),
})

export const organizationVS = countrySwitch(baseOrganizationVS, {
  IT: organizationITAVS,
})
